export default "__VITE_ASSET__f963bb34__"